/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IClRegionData } from "Interfaces/SiteContent/IClRegionData";

import {
  CL_REGION_LOAD,
  CL_REGION_LOAD_FAILURE,
  CL_REGION_LOAD_SUCCESS,
  GEO_DATA_LOAD,
  GEO_DATA_LOAD_FAILURE,
  GEO_DATA_LOAD_SUCCESS,
} from "./ClRegionActionTypes";

/**
 * Action for getting the cl regions
 */
export interface IGetClRegions {
  type: typeof CL_REGION_LOAD;
}

/**
 * Action getting the cl regions when successful
 */
export interface IGetClRegionsSuccess {
  type: typeof CL_REGION_LOAD_SUCCESS;
  regions: IClRegionData[];
}

/**
 * Action getting the cl regions when failure
 */
export interface IGetClRegionsFailure {
  type: typeof CL_REGION_LOAD_FAILURE;
  regionsLoadError: string;
}

/**
 * Action for getting the geo data.
 */
export interface IGetGeoData {
  type: typeof GEO_DATA_LOAD;
}

/**
 * Action for getting the geo data success.
 */
export interface IGetGeoDataSuccess {
  type: typeof GEO_DATA_LOAD_SUCCESS;
  geoData: IClRegionData[];
}

/**
 * Action for getting the geo data failure.
 */
export interface IGetGeoDataFailure {
  type: typeof GEO_DATA_LOAD_FAILURE;
  geoDataLoadError: string;
}

/**
 * Action creator for getting the cl regions
 */
export const getClRegions = (): ClRegionsActionTypes => ({
  type: CL_REGION_LOAD,
});

/**
 * Action creator for getting cl regions when success
 * @param regions
 */
export const getClRegionsSuccess = (regions: IClRegionData[]): ClRegionsActionTypes => ({
  type: CL_REGION_LOAD_SUCCESS,
  regions,
});

/**
 * Action creator for getting cl regions when failure
 * @param regionsLoadError
 */
export const getClRegionsFailure = (regionsLoadError: string): ClRegionsActionTypes => ({
  type: CL_REGION_LOAD_FAILURE,
  regionsLoadError,
});

/**
 * Action creator for getting the geo data.
 */
export const getGeoData = (): ClRegionsActionTypes => ({
  type: GEO_DATA_LOAD,
});

/**
 * Action creator for getting geo data when success
 * @param regions
 */
export const getGeoDataSuccess = (geoData: IClRegionData[]): ClRegionsActionTypes => ({
  type: GEO_DATA_LOAD_SUCCESS,
  geoData,
});

/**
 * Action creator for getting geo data when failure
 * @param geoDataLoadError
 */
export const getGeoDataFailure = (geoDataLoadError: string): ClRegionsActionTypes => ({
  type: GEO_DATA_LOAD_FAILURE,
  geoDataLoadError,
});

export type ClRegionsActionTypes =
  | IGetClRegions
  | IGetClRegionsSuccess
  | IGetClRegionsFailure
  | IGetGeoData
  | IGetGeoDataSuccess
  | IGetGeoDataFailure;
